import { Typography, Box, useTheme } from "@mui/material";
import {cobotColours} from "../theme/theme";


const Header = ( {title, subtitle, color, size} ) => {

    const cobotTheme = useTheme();
    const colors = cobotColours(cobotTheme.palette);


    return (
        <Box padding="40px">
            <Typography
                variant="h3"
                color={colors.text.white}
                fontWeight="bold"
                sx={{ mb: "5px" }}
            >
                {title}
            </Typography>
            <Typography variant="h4" color={{color} || colors.secondary.forest } >
                {subtitle}
            </Typography>
        </Box>
    )
}

export default Header; 